import ConfigPreviewModal from "./configPreviewModal";

export default ConfigPreviewModal;
